// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Venezuela */
const VE = /^(?:4(?:1[24-8]|2[246])\d{7})$/;

export default VE;
